import Navbar from "../../../components/Navbar2";
import PricingPage from "./misc/PricingPage";

function ConsolePricing() {
  return (
    <>
      <Navbar title="Login" link="/login" />
      <PricingPage />
    </>
  );
}

export default ConsolePricing;
